import { axios as client } from './apiAdmin';
export const menuApi = {
  addMenus: data => {
    return client.post(`${data?.userType == 'admin' ? 'admin-user/' : ''}menus`, data).then(res => res.data);
  },
  getMenus: data => {
    return client.get(`${data?.userType == 'admin' ? 'admin-user/' : ''}menus`, { params: data }).then(res => res.data);
  },
  deleteMenus: data => {
    return client.delete(`${data?.userType == 'admin' ? 'admin-user/' : ''}menus/${data.id}`).then(res => res.data);
  },
  changeMenusStatus: data => {
    return client.put(`${data?.userType == 'admin' ? 'admin-user/' : ''}menus/${data.id}/status`, data).then(res => res.data);
  },
  changeMenus: data => {
    return client.put(`${data?.userType == 'admin' ? 'admin-user/' : ''}menus/${data.id}`, data).then(res => res.data);
  },
  getMenusDetail: data => {
    return client.get(`${data?.userType == 'admin' ? 'admin-user/' : ''}menus/${data.id}`, { params: data }).then(res => res.data);
  },
  sortMenus: data => {
    return client.put(`${data?.userType == 'admin' ? 'admin-user/' : ''}menus/swap-order`, data).then(res => res.data);
  },

}